import { useRef } from 'react';
export const useEnterKeyFormSubmit = () => {
    const submitButtonRef = useRef(null);
    return {
        submitButtonRef,
        onKeyDownHandler: (event) => {
            if (event.key === 'Enter' && !event.shiftKey && submitButtonRef.current) {
                event.preventDefault();
                submitButtonRef.current.click();
            }
        }
    };
};
//# sourceMappingURL=useEnterKeyFormSubmit.js.map